const BASE = 'https://api.tabtrips.com/olivrweb/hotelapi/Api.php';

// Cookie utility function
const getCookie = (name) => {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) {
      try {
        return decodeURIComponent(c.substring(nameEQ.length, c.length));
      } catch {
        return c.substring(nameEQ.length, c.length);
      }
    }
  }
  return null;
};

/**
 * Api.php is shared with extranet/public — do NOT send X-Tabtrips-Admin
 * or other RBAC feature headers. Bearer is optional (as before).
 */
const getHeaders = () => {
  const token = getCookie('adminToken');
  const headers = { 'Content-Type': 'application/json' };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

export const bookingApi = {
  searchInstantHotel: async (query) => {
    const res = await fetch(`${BASE}/getInstantHotel`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify({ query }),
    });
    if (!res.ok) throw new Error(`Search failed: ${res.status}`);
    return res.json();
  },

  getHotelDetailsWithPricing: async ({ hotelId, guests, checkIn, checkOut }) => {
    const params = new URLSearchParams({
      hotel_id: String(hotelId),
      guests: String(guests),
      check_in: checkIn,
      check_out: checkOut,
    }).toString();
    const res = await fetch(`${BASE}/getHotelDetailsWithCorrectPricing?${params}`, {
      headers: getHeaders(),
    });
    if (!res.ok) throw new Error(`Details failed: ${res.status}`);
    return res.json();
  },

  getUpdatedPrice: async (payload) => {
    const res = await fetch(`${BASE}/getUpdatedPrice`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error(`Update price failed: ${res.status}`);
    return res.json();
  },

  /** adminPanel.php — feature-gated on server via Bearer */
  payAtHotelBooking: async (payload) => {
    const res = await fetch(
      'https://api.tabtrips.com/olivrweb/hotelapi/adminPanel.php/payAtHotelBooking',
      {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify(payload),
      }
    );
    if (res.status === 401) {
      document.cookie = 'adminToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      document.cookie = 'adminUser=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      try {
        localStorage.removeItem('adminUser');
      } catch (_) {
        /* ignore */
      }
      window.location.href = '/login';
      throw new Error('Unauthorized');
    }
    if (res.status === 403) {
      const body = await res.json().catch(() => ({}));
      const err = new Error(
        body.required_feature
          ? `No access (required: ${body.required_feature})`
          : body.message || 'No access'
      );
      err.status = 403;
      err.required_feature = body.required_feature;
      err.data = body;
      throw err;
    }
    if (!res.ok) throw new Error(`Booking failed: ${res.status}`);
    return res.json();
  },
};
